import { render, staticRenderFns } from "./ViewTable.vue?vue&type=template&id=57304990&"
import script from "./ViewTable.vue?vue&type=script&lang=js&"
export * from "./ViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports